export enum InteractionInformationEvents {
  SENT_TICKET_TO_TRAINING = "interaction_information_sent_ticket_to_training",
  OPENED_TICKET_SCORE = "interaction_information_opened_ticket_score",
  ADJUSTED_TICKET_AI_SCORE = "interaction_information_adjusted_ticket_ai_score",
  ADJUSTED_CONVERSATION_AI_SCORE = "interaction_information_adjusted_conversation_ai_score",
  VIEWED_TRANSCRIPT_TAB = "interaction_information_viewed_transcript_tab",
  VIEWED_EVALUATIONS_TAB = "interaction_information_viewed_evaluations_tab",
}
